import styled from "styled-components";

import { LoadingOutlined } from "@ant-design/icons";
import { Form as Unform } from "@unform/web";

export const Container = styled.section`
  display: flex;
  align-items: center;
  flex-direction: column;
  justify-content: flex-start;

  width: 100%;
  height: 100%;
  max-width: 30rem;

  .report-with-select-country {
    display: flex;
    align-items: center;
    justify-content: space-between;

    @media (max-width: 690px) {
      flex-wrap: wrap;
    }
  }

  .mobile-select-country {
    margin-bottom: 1rem;
  }
`;

export const Form = styled(Unform)`
  display: flex;
  flex-direction: column;

  width: 100%;

  gap: 2rem;

  .coupon-container {
    padding: 0;
    margin: 0 0 2rem;
  }
`;

export const LoadingIcon = styled(LoadingOutlined)`
  margin: 0 1rem 0 0;
`;

export const PurchaseSummary = styled.p`
  padding: 1rem 0;
  font-family: Inter;
  font-size: 16px;
  font-weight: 600;
  line-height: 24px;
  text-align: left;

  margin: 0;

  border-bottom: 0.063rem solid
    ${({ theme }) => theme.checkoutStepsOffers?.widgetBackground};
`;
